module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/isarray/index.js
// module id = 678
// module chunks = 26 27 29